import type { SVGProps } from "react";
import { Shield } from "lucide-react";

export function AdminIcon(props: SVGProps<SVGSVGElement>) {
  return <Shield color="currentColor" {...props} className={`w-6 h-6 ${props.className ?? ""}`} />;
}
